import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  checkPaymentStatus,
  reloadServices,
  updateDepositAccountRecommendedPackagePaymentStatus,
} from '../../../../ServicePickerWidget';
import { sleep } from '../../../../common/utils/sleep';
import { selectConfigValue } from '../../../../ServicePickerWidget/selectors/config';
import { updateDepositAccountPayment } from '../../../../ServicePickerWidget/actions/depositAccount';
import { changePlacingType } from '../../../../ServicePickerWidget/actions/publishTerms';

export const usePayPackageMicrofrontendEvents = () => {
  const loadPublishTermsTimeout = useSelector(selectConfigValue('loadPublishTermsAfterBuyPackageTimeout'));

  const dispatch = useDispatch();

  const paymentSuccessHandler = async (e: CustomEvent) => {
    // КОСТЫЛЬ: Сбрасываем тип размещения, чтобы проставлялся чекбокс «Из пакета» после запроса check-service
    dispatch(changePlacingType(null));

    if (e.detail.paymentId) {
      const { paymentId, provider } = e.detail;

      dispatch(updateDepositAccountPayment({ paymentId, provider }));

      dispatch(
        checkPaymentStatus({
          paymentId,
          provider,
          setStatusAction: updateDepositAccountRecommendedPackagePaymentStatus,
        }),
      );
    } else {
      // КОСТЫЛЬ: Даём время на покупку пакета на бэке
      await sleep(loadPublishTermsTimeout);

      dispatch(reloadServices());
    }
  };

  React.useEffect(() => {
    window.addEventListener('payment-success', paymentSuccessHandler);

    return () => {
      window.removeEventListener('payment-success', paymentSuccessHandler);
    };
  });
};
